import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuerySample } from '@store/helpers';
import { COVERAGE_AREA_TABLE_DEFAULT_PAGE_SIZE } from '@src/utils/constants';
import { removeCounty } from '@src/utils';

const removeCountyFromLabel = (items: any[] = []) =>
  items.map((item) => ({
    ...item,
    label: removeCounty(String(item?.label ?? item?.value ?? '')),
  }));

export const coverageAreaApi = createApi({
  reducerPath: 'CoverageArea',
  tagTypes: ['CoverageArea'],
  baseQuery: baseQuerySample,
  endpoints: (builder) => ({
    getStates: builder.query({
      query: () => ({
        url: '/v1/places/district/states',
      }),
    }),
    getCountries: builder.query({
      query: ({ state: { id = 1 } }) => ({
        url: `/v1/places/district/cities/${id}`,
      }),
      transformResponse: removeCountyFromLabel,
    }),
    getCities: builder.query({
      query: ({ county: { id = 1 } }) => ({
        url: `/v1/places/district/districts/${id}`,
      }),
      transformResponse: removeCountyFromLabel,
    }),
    getZipCodes: builder.query({
      query: ({ id }) => ({
        url: `/v1/places/district/zip-code/${id}`,
      }),
    }),

    getCoverageAreaTableData: builder.mutation({
      query: ({ body = {}, params = {} }) => ({
        url: `/v2/contractors/us-zip-codes`,
        method: 'POST',
        body,
        params: {
          sortBy: 'state',
          sortDir: 'desc',
          page: 0,
          size: COVERAGE_AREA_TABLE_DEFAULT_PAGE_SIZE,
          ...params,
        },
      }),
    }),

    updateArea: builder.mutation({
      query: ({ body = {}, id }) => ({
        url: `/v2/contractors/us-zip-codes/update/${id}`,
        method: 'PUT',
        body,
      }),
    }),

    getCoverageAreaById: builder.query({
      query: ({ id }) => ({
        url: `/v2/contractors/us-zip-codes/${id}`,
      }),
    }),
    getBusinessHoursTableData: builder.query({
      query: () => ({
        url: `/v2/contractors/business-hours`,
      }),
    }),
    createOrUpdateBusinessHours: builder.mutation({
      query: ({ body = {} }) => ({
        url: `/v2/contractors/business-hours`,
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const {
  useLazyGetStatesQuery,
  useLazyGetCountriesQuery,
  useLazyGetCitiesQuery,
  useUpdateAreaMutation,
  useLazyGetCoverageAreaByIdQuery,
  useLazyGetZipCodesQuery,
  useGetCoverageAreaTableDataMutation,
  useLazyGetBusinessHoursTableDataQuery,
  useCreateOrUpdateBusinessHoursMutation,
} = coverageAreaApi;
